module.exports = __webpack_public_path__ + "static/media/checkmark_active_boostabostad.485303f5.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/checkmark_active_boostabostad.svg
// module id = 128
// module chunks = 0